// @flow
import * as React from 'react';

export const getFilename = (file: ?React.Element<any>): string => {
  // Grab the filename prop from the File component
  const filename = file?.props?.children?.props?.children?.props?.filename;
  return filename || '';
};
